import {Base} from "@/api/Base"

export class LeaveApprove extends Base {
    path = "leave/approve"
}